<template>
  <!--展示-->
  <div class=""
       v-if="pageType === '0'">
    <header-nav :navInfo="navInfo1"
                @backFunc="backFunc">
      <span slot="right"
            class="right"
            @click="toAddPage">
        新增发票
      </span>
    </header-nav>

    <div class="page-body"
         v-if="invoiceList.length > 0">
      <div class="item-box"
           v-for="(item, index) in invoiceList"
           :key="index">
        <div class="item-info">
          <p>{{item.name}}</p>
          <p>{{item.taxpayercode}}</p>
        </div>

        <div class="item-btns">

          <div class="item-btn del-btn"
               @click="delInvoiceFunc(item.id)">删除发票</div>
        </div>
      </div>

      <van-pagination v-model="pageParams.pageNumber"
                      :total-items="total"
                      :show-page-size="3"
                      force-ellipses />
    </div>
    <div class="page-body no-data"
         v-else>
      暂无数据
    </div>
  </div>
  <!--新增-->
  <div class=""
       v-else-if="pageType === '1'">
    <header-nav :navInfo="navInfo2"
                @backFunc="pageType = '0'"></header-nav>

    <div class="page-body">
      <van-form @submit="addInvoice">
        <van-cell-group inset>
          <van-field v-model="invoiceData.name"
                     name="公司名称"
                     label="公司名称"
                     placeholder="公司名称"
                     :rules="[{ required: true, message: '请填写公司名称' }]" />
          <van-field v-model="invoiceData.taxpayercode"
                     name="税号"
                     label="税号"
                     placeholder="税号"
                     :rules="[{ required: true, message: '请填写税号' }]" />
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button round
                      block
                      type="primary"
                      native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
      <!-- <el-form ref="form"
               :model="invoiceData"
               label-width="80px">
        <el-form-item label="公司名称">
          <el-input v-model="invoiceData.name"
                    placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="税号">
          <el-input v-model="invoiceData.taxpayercode"
                    placeholder="请输入税号"></el-input>
        </el-form-item>
      </el-form>

      <div class="submit"
           @click="addInvoice">
        确认提交
      </div> -->
    </div>
  </div>

</template>

<script>
import HeaderNav from '@/components/head-nav'
import { getInvoiceListReq } from '@/api/user'
export default {
  name: "index",
  props: ['userData'],
  components: {
    HeaderNav
  },
  data () {
    return {
      navInfo1: {
        tit: '发票信息',
      },
      navInfo2: {
        tit: '新增发票抬头',
      },
      pageType: '0',
      invoiceData: {
        name: '',
        taxpayercode: '',
      },
      invoiceList: [],
      pageParams: {
        pageNumber: 0,
        pageSize: 10
      },
      total: 0
    }
  },
  mounted () {
    // let type = this.$route.query.type;

    // this.pageType = type || '0';

    // this.getUserInfo();
    this.getInvoiceList()
  },
  methods: {
    async getInvoiceList () {
      const res = await getInvoiceListReq(this.pageParams)
      const resData = res.data
      if (resData.code === 200) {
        this.invoiceList = resData.data.content
        this.total = resData.data.totalElements
      }
    },
    addInvoice () {

    },
    // addInvoice() {
    //     if (this.invoiceData.name.length === 0) {
    //         this.$message({
    //             message: '请输入公司名称',
    //             type: 'warning'
    //         });
    //         return false;
    //     } else if (this.invoiceData.taxpayercode.length === 0) {
    //         this.$message({
    //             message: '请输入公司识别号',
    //             type: 'warning'
    //         });
    //         return false;
    //     }
    //     let token = sessionStorage.getItem('token');
    //     let params={
    //         'ACCESS-TOKEN': token,
    //         'companyName': this.invoiceData.name,
    //         'taxpayerCode': this.invoiceData.taxpayercode
    //     };
    //     params = this.$qs.stringify(params);
    //     this.$axios.post(this.$httpApi.user.addInvoice,params).then((response) =>{
    //             if(response.data.code=='100000'){
    //                 // this.invoiceData.name='';
    //                 // this.invoiceData.taxpayercode='';
    //                 this.$message({
    //                     message: '恭喜你，新增发票成功！',
    //                     type: 'success'
    //                 });
    //                 this.pageType = '0';
    //                 this.getUserInfo();
    //             }else{
    //                 this.$message({
    //                     message: response.data.message,
    //                     type: "error",
    //                     showClose: true
    //                 });
    //             }
    //         }
    //     );
    // },
    // delInvoiceFunc(id) {
    //     let token = sessionStorage.getItem('token');
    //     this.$axios.get(this.$httpApi.user.delInvoice,{
    //         params:{
    //             'ACCESS-TOKEN': token,
    //             'invoiceId':id
    //         }
    //     }).then((response) =>{
    //             if(response.data.code=='100000'){
    //                 this.$message({
    //                     message: '删除成功',
    //                     type: 'success'
    //                 });
    //                 this.getUserInfo();
    //             }else{
    //                 this.$message({
    //                     message: response.data.message,
    //                     type: "error",
    //                     showClose: true
    //                 });
    //             }
    //         }
    //     );
    // },
    backFunc () {
      this.$router.back();
    },
    // getUserInfo() {
    //     this.$emit('getUserInfo')
    // },
    toAddPage () {
      this.pageType = '1';

      this.getCityList(1);
    },
  }
}
</script>

<style scoped lang="stylus">
.right
  position absolute
  top 0
  right 10px
  font-size 14px
  font-weight bold
  color #34d1bc
  white-space nowrap

.page-body
  width 100%
  height auto
  padding 0 15px
  margin-top 10px
  -webkit-box-sizing border-box
  -moz-box-sizing border-box
  box-sizing border-box

.page-body .el-form-item.el-form-item__label
  color #91a6bd
  font-size 14px

.no-data
  margin-top 50px
  text-align center
  color #91a6bd

.item-info
  padding 15px 0

.item-box
  width 100%
  height auto
  padding 0 15px
  font-size 14px
  margin-bottom 15px
  background rgba(255, 255, 255, 1)
  box-shadow 0px 2px 4px 0px rgba(0, 60, 171, 0.2)
  border-radius 4px
  -webkit-box-sizing border-box
  -moz-box-sizing border-box
  box-sizing border-box

.item-box p
  line-height 28px

.item-btns
  display flex
  height 40px
  justify-content center
  align-items center
  border-top 1px solid #e6e6e6

.item-btns > .item-btn
  text-align center
  flex 1

.edit-btn
  color #34d1bc

.del-btn
  color #91a6bd

.add-item
  margin-bottom 20px

.add-item-body
  display flex
  align-items center
  justify-content space-around
  width 100%

.label
  display block
  color #91a6bd
  margin-bottom 20px

.submit
  width 240px
  height 40px
  color #fff
  font-size 14px
  margin 0 auto
  text-align center
  line-height 40px
  background rgba(52, 209, 188, 1)
  box-shadow 0px 2px 6px 0px rgba(52, 209, 188, 0.2)
  border-radius 20px
</style>